export default function nameMinusExtension(filename = "") {
  const segs = filename.split(".");
  if (segs.length > 1) return segs.slice(0, -1).join(".");
  return filename;
}
